import { useSuspenseQuery } from '@apollo/client';
import { type HomePageQuery, type HomePageQueryVariables, QUERY_HOME_PAGE } from '@edwin-group/people-graphql';

export const useHome = () => {
  const { data: homePage } = useSuspenseQuery<HomePageQuery, HomePageQueryVariables>(QUERY_HOME_PAGE, {
    fetchPolicy: 'cache-first',
  });

  return {
    homePage,
  };
};
